import { Grid, IconButton } from "@mui/material";
import { useParams } from "react-router-dom";
import useDisclosure, {
  DisclosureHost,
} from "../../../../hooks/use-disclosure";
import { useGetUserDetail } from "../../../../queries/use-get-pertiCular-user";
import ProfileViewer from "../../../ProfileViewer";
import SideSheetDrawer from "../../../SidesheetDrawer";
import {
  DEFAULT_USER_SRC,
  DEFAULT_VALUE_LABEL_LIST,
  getUnNecessaryTransformData,
  transformMultiSelectFrontEndVal,
} from "../../../../utils/utils";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import UpsertStaffUserDrawer from "../../admin/provider-groups/UpsertStaffUserDrawer";
import { useUpdateUser } from "../../../../queries/use-update-user";
import { formatDate } from "../../../../utils/date-time-utility";
import { GENDER_RECORD } from "../../../../constants";

interface UserProfileModalProps {
  disClosureHost: DisclosureHost;
  dialogTitle: string;
  userId?: string;
}

const UserProfileDrawer: React.FC<UserProfileModalProps> = ({
  disClosureHost,
  dialogTitle,
  userId,
}) => {
  const {
    opened: openedStaffUserModal,
    open: openStaffUserModal,
    close: closeStaffUserModal,
  } = useDisclosure(false);

  const params = useParams();
  const { data: res, refetch } = useGetUserDetail({
    userId,
    xTENANTID: params?.providerGroupId,
    disable: !userId,
  });
  const userData = res?.data;
  const { mutateAsync: updateStaffUser } = useUpdateUser();

  const editStaffUser = (values: any) => {
    const transFormData: any = getUnNecessaryTransformData(
      ["workLocations"],
      values
    );

    return updateStaffUser({
      user: transFormData,
      xTENANTID: params?.providerGroupId,
    }).then((res) => {
      refetch();
      return res;
    });
  };

  const minW = "950px";

  return (
    <SideSheetDrawer
      w={minW}
      open={disClosureHost.opened}
      onClose={disClosureHost.close}
      title={dialogTitle}
      endIcon={
        <IconButton onClick={openStaffUserModal}>
          <ModeEditOutlineOutlinedIcon />
        </IconButton>
      }
    >
      <UpsertStaffUserDrawer
        open={openedStaffUserModal}
        modalTitle="Edit Staff User"
        onClose={closeStaffUserModal}
        initialValues={{
          ...userData,
          workLocations: userData?.workLocations
            ? transformMultiSelectFrontEndVal(
                DEFAULT_VALUE_LABEL_LIST,
                userData?.workLocations
              )
            : undefined,
        }}
        onSubmit={editStaffUser}
      />

      <Grid item container minWidth={minW} maxWidth={"1027px"}>
        <Grid item container xs={3.2}>
          <img
            src={userData?.avatar ?? DEFAULT_USER_SRC}
            alt={userData?.name}
            style={{ borderRadius: "10px" }}
            width={"212px"}
            height={"212px"}
          />
        </Grid>
        <Grid item container xs={8.8}>
          <Grid item xs={6}>
            <ProfileViewer
              gap={"30px"}
              withoutColn
              firstColW={4.5}
              secondColW={7.5}
              data={{
                name: `${userData?.firstName ?? ""} ${
                  userData?.lastName ?? ""
                }`,
                DOB: formatDate(userData?.birthDate) ?? "",
                "Contact Number": userData?.phone,
                Role: userData?.role,
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <ProfileViewer
              gap={"30px"}
              withoutColn
              firstColW={4.5}
              secondColW={7.5}
              data={{
                "email Id": userData?.email,
                gender: userData?.gender ? GENDER_RECORD[userData?.gender] : "",
                "User Type": userData?.roleType,
              }}
            />
          </Grid>
          {/* <Grid item xs={6}>
            <Typography variant="body2">Name</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              {userData?.firstName ?? "" + " " + userData?.lastName ?? ""}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">Email Id</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>{userData?.email}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">Office Phone Number</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>{userData?.phone}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">User Type</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>Admin</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2">Role</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography>
              {ROLES_LIST.find((el) => el.value == userData?.role)?.label ??
                ROLES_LIST[0].label}
            </Typography>
          </Grid>
        </Grid> */}
        </Grid>
      </Grid>
    </SideSheetDrawer>
  );
};

export default UserProfileDrawer;
